
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/transportbil",
      function () {
        return require("private-next-pages/wheels/transportbil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/transportbil"])
      });
    }
  